import * as types from '../types'
let cookie = require('../../assets/js/cookie');
let store = require('../../store');
let http = require('../../assets/js/http.js');

const state = {
  homeMenu: "",
  subMenu: "",
  menuList: [],
  activeIndex : "",
  activeIndexIcon: "",
  operatorType:"",
  path:"",
};

const getters = {
  homeMenu:()=>{
    return state.homeMenu;
  },
  subMenu:()=>{
    return state.subMenu;
  },
  menuList:()=>{
    return state.menuList;
  },
  activeIndex:()=>{
    return state.activeIndex;
  },
  activeIndexIcon:()=>{
    return state.activeIndexIcon;
  },
};

const actions = {
};

const mutations = {
  [types.GETMENULIST](state,playload){
    var menuListString = undefined;
    if(localStorage.getItem('menuList')){
      menuListString=localStorage.getItem('menuList')
    }else {
      menuListString=cookie.getCookie("menuList");
      localStorage.setItem('menuList',menuListString);
    }

    if (menuListString == undefined || menuListString == "") {
      return;
    }

    state.operatorType  = cookie.getCookie("operatorType");
    //var menuListInfo = JSON.parse(decodeURIComponent(menuListString));
    var menuListInfo = JSON.parse(menuListString);
    for(var i=0;i < menuListInfo.length; i++){
      if (menuListInfo[i].menuId == 10 && state.operatorType == "RESIDENCE") {
        menuListInfo.splice(i,1);
      } else if (menuListInfo[i].menuId == 20 && state.operatorType == "APARTMENT") {
        menuListInfo.splice(i,1);
      }
      if(menuListInfo[i].menuId == 70 && state.operatorType=='RESIDENCE'){
        menuListInfo.splice(i,1);
      }
    }
    if (localStorage.getItem("organId")=='162'){
    } else {
      menuListInfo.pop()
    }
    state.menuList = menuListInfo;
  },
  [types.ACTIVEMENU](state,playload){
    let url = playload,that = this;
    if (url == undefined) {
      url = window.location.href;
      if (url && url.split('#').pop() != "") {
        url = url.split('#').pop().split('/')[1];
      } else {
        url = "/";
      }
    } else {
      url = url.substr(1,url.length-1).split('#').pop().split('/')[0];
    }
    if (url == "" || url == "/" || url == "login") {
      if (state.operatorType == "RESIDENCE") {
        state.activeIndex = '/residence';
      } else {
        state.activeIndex = '/index';
      }
    } else {
      state.activeIndex = "/" + url;
    }
    for(var i = 0; i < state.menuList.length; i++){
      for(var j = 0; j < state.menuList[i].subMenuList.length; j++){
        if(("/" + state.menuList[i].subMenuList[j].menuUrl) == state.activeIndex){
          state.homeMenu = state.menuList[i].menuName;
          state.subMenu = state.menuList[i].subMenuList[j].menuName;
          state.activeIndex = '/'+state.menuList[i].subMenuList[j].menuUrl;
          state.activeIndexIcon = '/'+state.menuList[i].subMenuList[0].menuUrl;
        }
      }
    }
    let detailUrl = playload.substr(1,playload.length-1).split('#').pop().split('/')[1];
    if(detailUrl != 'residenceRoomDetail' && detailUrl != 'roomDetail'){
      store.default.commit(types.SETMENU, {
        "homeMenu":state.homeMenu,
        "subMenu":state.subMenu
      })
    }
  },
  [types.SETMENU](state,playload){
    state.homeMenu = playload.homeMenu;
    state.subMenu = playload.subMenu;
  },
  [types.GETPATH](state,playload){
    state.path = playload.path;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js